export const validateSlug = (value: string): boolean => {
  const regexp_rfc3986 = new RegExp('["<>\\^`{|}]')
  const regexp = new RegExp('^(https?:\\/\\/|\\/)\\wа-я+\\.[^\\s]+$|^[^\\s]*$')

  return !(
    regexp_rfc3986.test(value) ||
    !regexp.test(value) ||
    value.length > 2048
  )
}
